module.exports = __webpack_public_path__ + "static/media/exitIcon.94e402a9.svg";